import { sendError } from '@components/Noti';
import { $isVip } from '@stores/memberStores';
import {
  type Files,
  type MatrixCheckResult,
  TaskAction,
  type TaskRequestItem,
} from '@types';
import { toFlag } from 'pano-utils';
import domain from '../../domain';
import { $libUploadingMatrix } from '../../stores/libUploading';
import matrixImageCheck from './matrixImageCheck';
import matrixUpload from './matrixUpload';
import { taskCreateApi } from './taskApis';

const matrixTask = domain.effect(
  async ({
    albumId,
    files,
    watermarked = false,
  }: {
    albumId: number;
    files: Files;
    watermarked?: boolean;
  }) => {
    const isVip = $isVip.getState();
    const taskMap = new Map<string, MatrixCheckResult>();
    const materials: TaskRequestItem[] = [];
    for (let i = 0; i < files.length; i++) {
      const result = await matrixImageCheck(files[i], !!isVip);
      if (result) {
        $libUploadingMatrix.api.add({ id: result.id, name: result.name });
        taskMap.set(result.id, result);
        materials.push({
          action: TaskAction.new,
          albumId,
          exif: result.exif,
          fileId: result.id,
          gps: result.gps,
          name: result.name,
          size: result.size,
          watermarked: toFlag(watermarked),
        });
      }
    }
    if (!materials.length) return;
    const tasks = await taskCreateApi(materials);
    for (let i = 0; i < tasks.length; i++) {
      const taskResp = tasks[i];
      const taskItem = taskMap.get(taskResp.fileId);
      if (!taskItem) return;
      $libUploadingMatrix.api.libId({
        id: taskItem.id,
        libId: taskResp.materialId,
      });
      const onProgress = (progress: string) => {
        $libUploadingMatrix.api.progress({ id: taskItem.id, progress });
      };
      await matrixUpload({ taskResp, taskItem, onProgress });
      $libUploadingMatrix.api.progress({ id: taskItem.id, progress: '制作中' });
    }
  }
);

matrixTask.failData.watch((e) => {
  sendError(e.message);
});

export default matrixTask;
